export default __webpack_public_path__ + "static/media/Chestguard of the Valiant.c731092d.jpg";